












import router from '@/router';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class Home extends Vue {
  createGame(): void {
    router.push({
      name: 'PoqerRoom',
      params: { roomId: this.generateRoomId(10) }
    });
  }

  generateRoomId(length: number): string {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}
